import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const AdminPLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1408 1024q0 26-10 49t-27 41-41 28-50 10V897q27 0 50 10t40 27 28 40 10 50zm616 86l-63 241-212-28q-17 26-35 50t-41 46l74 192-216 126-128-168q-60 15-123 15v-210q72 0 135-27t111-75 74-110 28-136q0-72-27-135t-75-111-110-75-136-28V461h5l79-180 241 64-27 205q27 17 52 37t48 44l188-72 125 215-167 129q13 59 13 124l187 83zM769 850q0 72-38 101t-105 29h-25q-12 0-25-1V728q17-1 33-2t34-1q126 0 126 125zM64 272L1216 67v1914L64 1782V272zm363 1115l149 18v-288q75 2 142-9t118-44 79-88 30-144q0-122-65-186t-186-64q-66 0-133 5t-134 10v790z" />
    </svg>
  ),
  displayName: 'AdminPLogoInverse32Icon',
});

export default AdminPLogoInverse32Icon;
